


































































































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import CategoriesApi from "@/services/CategoriesApi";
import MaterialGroupApi from "@/services/MaterialGroups";
import MaterialApi from "@/services/Materials";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import { Category, MaterialGroupList, SortDirection } from "@/api/lab-base-api-client";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class MMaterialList extends CheckAdminLogin {
  // tabのcategory一覧配列
  private categories: Category[] = [];

  // activeTabのcategoryId変数
  private activeTab = -1;

  // tableのheader設定配列
  private headers = [
    {
      text: "content name",
      align: "start",
      sortable: false,
      value: "name",
    },
    { text: "page", align: "center", value: "materials.length", sortable: false },
    { text: "status", align: "center", value: "status", sortable: false },
    { text: "", align: "center", value: "actions", sortable: false },
  ];

  // tableのデータ配列
  private listItems: MaterialGroupList[] = [];

  // 削除対象materialGroupのuuid
  private targetItemUuid = "";

  private isDeleteMaterialGroupDialog = false;

  // ページ読み込み時に実行
  private async mounted() {
    await this.fetchCategories();
    await this.fetchList(0);
  }

  // category一覧取得
  private async fetchCategories() {
    const categoriesRes = await CategoriesApi.instance.getCategories();
    this.categories = categoriesRes.data.data.categories;
    this.activeTab = this.categories[0].id;
  }

  // コンテンツ一覧の取得
  private async fetchList(categoryIndex: number) {
    const materialGroupsRes = await MaterialGroupApi.instance.getMaterialGroup(
      undefined,
      undefined,
      SortDirection.Asc,
      undefined,
      undefined,
      true
    );

    // // カテゴリーが存在するmaterialGroup一覧
    const materialGroups = materialGroupsRes.data.data.items.filter(
      (materialGroup: { categories: {} }) => materialGroup.categories
    );

    // コンテンツの数分回す
    materialGroups.forEach((materialGroup: MaterialGroupList) => {
      // カテゴリ-の数分回す
      for (let i = 0; i < materialGroup.categories.length; i += 1) {
        // カテゴリーidとqueryのidが同一の場合以下を実行
        if (materialGroup.categories[i].id === this.categories[categoryIndex].id) {
          if (!materialGroup.materials) {
            return;
          }
          // 削除済みでないのmaterialのみに
          const material = materialGroup.materials.filter(
            // eslint-disable-next-line no-shadow
            (material: { deleted: boolean }) => !material.deleted
          );
          // eslint-disable-next-line no-param-reassign
          materialGroup.materials = material;
          this.listItems.push(materialGroup);
          // 降順に並び替え
          this.listItems.sort((a: { createdAt: string }, b: { createdAt: string }) => {
            if (a.createdAt < b.createdAt) return -1;
            if (a.createdAt > b.createdAt) return 1;
            return 0;
          });
        }
      }
    });
  }

  // tab切り替え時に実行
  private selectTab(id: number, index: number) {
    // 切り替えたtabのカテゴリーidを代入
    this.activeTab = id;
    this.listItems = [];
    this.fetchList(index);
  }

  // 削除アイコンclickで実行
  private async onDeleteMaterialGroup(uuid: string) {
    this.isDeleteMaterialGroupDialog = true;
    this.targetItemUuid = uuid;
  }

  // 削除ダイアログの「ok」クリックで実行
  private async deleteMaterialGroupItem(index: number) {
    await this.deleteMaterialGroup();
    this.closeDeleteMaterialGroupDialog();
    this.listItems = [];
    await this.fetchList(index);
  }

  /**
   * sort
   */
  private buttonStatus = true;

  /**
   * 教材のソート(順番の並び替え)
   */
  // NOTE: 現在api側未実装
  // private async upMenu(materialUuid: string) {
  //   console.log("up menu");
  //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //   const Direction: any = true;
  //   this.buttonStatus = false;
  //   try {
  //     await MaterialGroupApi.instance.updateMaterialGroupByUuId(materialUuid, Direction).then(() => {
  //       this.buttonStatus = true;
  //     });
  //   } catch (err) {
  //     console.log(err);
  //     this.buttonStatus = true;
  //   }
  //   // this.fetchList();
  // }
  // /修正内容

  // materialGroup、materialの削除
  private async deleteMaterialGroup() {
    try {
      // itemsに対象materialGroupを代入
      const items = this.listItems.find((item: MaterialGroupList) => {
        return item.uuid === this.targetItemUuid;
      });

      // materialが登録されていた場合material全削除
      if (items && items.materials) {
        await items.materials.forEach((material: { uuid: string }) => {
          MaterialApi.instance.deleteMaterialById(material.uuid);
        });
      }
      // materialGroup削除
      if (this.targetItemUuid) {
        await MaterialGroupApi.instance.deleteMaterialGroupById(this.targetItemUuid);
      }
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // materialGroup削除ダイアログを閉じる
  private closeDeleteMaterialGroupDialog() {
    this.isDeleteMaterialGroupDialog = false;
  }

  // 第一引数のMaterialGroupへのリンクを生成・コピー
  private copyLink(materialGroup: MaterialGroupList, categorySlug: string) {
    // リンクを生成
    if (!materialGroup.materials) {
      return;
    }
    const link = `${window.location.origin}${
      this.$router.resolve({
        name: "UContent",
        params: { category: categorySlug, content: materialGroup.name },
        query: { uuid: materialGroup.uuid, material: materialGroup.materials[0].uuid },
      }).href
    }`;
    // クリップボードにコピー
    navigator.clipboard.writeText(link);
  }

  // ステータスをセット
  private setStatus = (materialGroup: MaterialGroupList) => {
    if (materialGroup.planId) {
      return "プレミア";
    }
    return "ベーシック";
  };
}
